import React, { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import {
  DialogHeader,
  DialogHeading,
  GridLeft,
  GridRight,
  GridSection,
} from '../../Episode.Styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Grid, IconButton, Typography } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  dateFormat
} from '../../../../constants';
import FormInputMultiCheckbox from '../../../common/Forms/FormCheckbox';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

const CSTScoringGuide = (props) => {
  const { open, setOpen, participantInfo, episode, aorcmReferenceData, oras, tot1, tot2, tot3, tot4, tot5, tot6, tot7, totCST} = props;
  //console.log('### participantInfo')
  //console.log(participantInfo)
  //console.log('### oras')
  //console.log(oras)
  //console.log('### aorcmReferenceData')
  //console.log(aorcmReferenceData)

  const handleClose = () => {
    setOpen(false);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <DialogHeader>
        <DialogHeading variant="h5"></DialogHeading>
        <Box>
          <Button variant="contained" onClick={() => handlePrint()}>
            Print
          </Button>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogHeader>
        <Box px={4}>
        <Grid container spacing={1} ref={componentRef} sx={{paddingTop: '40px;', paddingLeft: '40px;', paddingRight: '40px;', width: '1200px;'}}>
            <Grid item xs={2}>
              <Box
                component="img"
                sx={{
                  display: 'flex', 
                  justifyContent: 'center',
                  height: 100,
                  width: 100,
                  maxHeight: { xs: 100, md: 100 },
                  maxWidth: { xs: 100, md: 100 },
                }}
                src="/westcare-logo.jpg"
              />
            </Grid>  
            <Grid item xs={10}>
              <Typography sx={{ textAlign: 'center' }} pt={5} variant="h5">ORAS - SCORING FOR THE COMMUNITY SUPERVISION TOOL CST</Typography>
              <Typography sx={{ textAlign: 'center', 'backgroundColor': 'yellow' }} variant="h5" >In the community for 90 days and in prision less than 4 years</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography variant="h5">Name: {participantInfo.key}</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ textAlign: 'right' }} variant="h5">Date of Assessment: {oras?.epdOrasAssessDate ? moment(oras?.epdOrasAssessDate).format(dateFormat) : ''}</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography variant="h5">CDC#: {episode.cDCNumber}</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ textAlign: 'right' }} pb={2} variant="h5">Community Service Specialist: {oras?.epdOrasCSSID ? aorcmReferenceData.caseManagerOrCMList.find(a => a.id==oras.epdOrasCSSID).value : ''}</Typography>
            </Grid>


            { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
            <GridLeft item xs={3}>
              Calculated Risk Category MALES
              <FormGroup>
                <FormControlLabel control={              
                  <Checkbox
                    checked={totCST<=14}
                  />}
                  label="0 - 14 Low"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totCST >=15 && totCST<=23}
                  />}
                  label="15 - 23 Moderate"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totCST >=24 && totCST<=33}
                  />}
                  label="24 - 33 High"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totCST >=34}
                  />}
                  label="34+ Very High"
                />
              </FormGroup>    
            </GridLeft>
            :
            <GridLeft item xs={3}>
              Calculated Risk Category FEMALES}
              <FormGroup>
                <FormControlLabel control={              
                  <Checkbox
                    checked={totCST<=14}
                  />}
                  label="0 - 14 Low"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totCST >=15 && totCST<=21}
                  />}
                  label="15 - 21 Low Moderate"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totCST >=22 && totCST<=28}
                  />}
                  label="22 - 28 Moderate"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totCST >=29}
                  />}
                  label="29+ High"
                />
              </FormGroup>    
            </GridLeft>
            }


            <Grid item xs={3} />
            <Grid item xs={6}>
              <FormGroup>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={oras?.isOverride}
                  />}
                  label="Professional Override"
                />
              </FormGroup>
              <TextField
                name='overrideReason'
                multiline={true}
                maxRows={2.5}
                type="text"
                label='Reason for Override'
                shrink={true}
                value={oras?.overrideReason}
                fullWidth
              />
              
            </Grid>             
          
          
          <Grid container>
            <Grid item xs={5} />
            <Grid item xs={1.5}>
              <Typography variant="h6">Override Level</Typography>
            </Grid>
            { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
            <Grid item xs={5.5}>
              <RadioGroup sx={{marginTop: '-8px;'}} row value={oras?.overrideLevel ?? ''}>
                <FormControlLabel
                  value='1'
                  label='LOW'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='2'
                  label='MODERATE'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='3'
                  label='HIGH'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='4'
                  label='VERY HIGH'
                  control={<Radio />}
                />
              </RadioGroup>  
            </Grid>
            :
            <Grid item xs={5.5}>
              <RadioGroup sx={{marginTop: '-8px;'}} row value={oras?.overrideLevel ?? ''}>
                <FormControlLabel
                  value='1'
                  label='LOW'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='2'
                  label='LOW/MODERATE'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='3'
                  label='MODERATE'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='4'
                  label='HIGH'
                  control={<Radio />}
                />
              </RadioGroup>  
            </Grid>
            }
          </Grid>



          <Grid item xs={12}>
            <Typography variant="h6">Recommendations;</Typography>
          </Grid>

          { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
          <>          
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totCST<=14 ? '800' : '400'} variant="h6">LOW</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totCST<=14 ? '800' : '400'} variant="h6">Minimum supervision or non-reporting supervision</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totCST >=15 && totCST<=23 ? '800' : '400'} variant="h6">MODERATE</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totCST >=15 && totCST<=23 ? '800' : '400'} variant="h6">Regular supervision; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totCST >=24 && totCST<=33 ? '800' : '400'} variant="h6">HIGH</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totCST >=24 && totCST<=33 ? '800' : '400'} variant="h6">Enhanced supervision or residential placement; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==4 ? '800' : '400' : totCST >=34 ? '800' : '400'} variant="h6">VERY HIGH</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==4 ? '800' : '400' : totCST >=34 ? '800' : '400'} variant="h6">Residential placement preferred or enhanced supervision at highest level; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          </>
          :
          <>          
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totCST<=14 ? '800' : '400'} variant="h6">LOW</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totCST<=14 ? '800' : '400'} variant="h6">Minimum supervision or non-reporting supervision</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totCST >=15 && totCST<=21 ? '800' : '400'} variant="h6">LOW MODERATE</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totCST >=15 && totCST<=21 ? '800' : '400'} variant="h6">Regular supervision; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totCST >=22 && totCST<=28 ? '800' : '400'} variant="h6">MODERATE</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totCST >=22 && totCST<=28 ? '800' : '400'} variant="h6">Enhanced supervision or residential placement; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==4 ? '800' : '400' : totCST >=29 ? '800' : '400'} variant="h6">HIGH</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==4 ? '800' : '400' : totCST >=29 ? '800' : '400'} variant="h6">Residential placement preferred or enhanced supervision at highest level; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          </>
          }


          <Grid item xs={12}>
            <Typography pt={1} variant="h6">Other Areas of Concern. Ckeck all that apply.</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_LowIntelligence}
                />}
                label="Low Intelligence"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_PhysicalHandicap}
                />}
                label="Physical Handicap"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_ReadWriteLimits}
                />}
                label="Read/Writing"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_MentalHealth}
                />}
                label="Mental Health"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_NoDesire}
                />}
                label="No Desire to Change"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Transportation}
                />}
                label="Transportation"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_ChildCare}
                />}
                label="Child Care"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Language}
                />}
                label="Language"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Ethnicity}
                />}
                label="Ethnicity"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Cultural}
                />}
                label="Cultural Barriers"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Cultural}
                />}
                label="History of Abuse/Neglect"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Interpersonal}
                />}
                label="Interpersonal Anxiety"
              />
            </FormGroup>
            </Grid>
            <Grid item xs={1}>
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox
                    checked={oras?.other_Other}
                  />}
                  label="Other"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={11}>    
              <TextField
                size="small"
                sx={{marginTop: '-16px;'}}
                name='overrideReason'
                type="text"
                label=''
                shrink={true}
                value={oras?.other_OtherDescr}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5">* If these items are checked it is strongly recommended that forther assessment be conducted to determine level or severity.</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography pt={1} variant="h5" sx={{fontWeight: '800'}}>Level of Need</Typography>
            </Grid>

            <GridLeft item xs={1.5}>
              <Typography variant="h5">HIGH</Typography>
              <Typography pt={1} variant="h5">MOD</Typography>
              <Typography pt={1} variant="h5">LOW</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot1 >=7 && tot1 <=8 ? '1px solid' : 'none')}} variant="h5">7-8</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot1 >=4 && tot1 <=6 ? '1px solid' : 'none')}} pt={1} variant="h5">4-6</Typography>
              <Typography sx={{ textAlign: 'center',  border: (tot1 >=0 && tot1 <=3 ? '1px solid' : 'none')}} pt={1} variant="h5">0-3</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot2 >=5 && tot2 <=6 ? '1px solid' : 'none') }} variant="h5">5-6</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot2 >=2 && tot2 <=4 ? '1px solid' : 'none') }} pt={1} variant="h5">2-4</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot2 >=0 && tot2 <=1 ? '1px solid' : 'none') }} pt={1} variant="h5">0-1</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot3 >=4 && tot3 <=5 ? '1px solid' : 'none') }} variant="h5">4-5</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot3 >=2 && tot3 <=3 ? '1px solid' : 'none') }} pt={1} variant="h5">2-3</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot3 >=0 && tot3 <=1 ? '1px solid' : 'none') }} pt={1} variant="h5">0-1</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot4 >=2 && tot4 <=3 ? '1px solid' : 'none') }} variant="h5">2-3</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot4 ==1 ? '1px solid' : 'none') }} pt={1} variant="h5">1</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot4 ==0 ? '1px solid' : 'none') }} pt={1} variant="h5">0</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot5 >=5 && tot5 <=6 ? '1px solid' : 'none') }} variant="h5">5-6</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot5 >=3 && tot5 <=4 ? '1px solid' : 'none') }} pt={1} variant="h5">3-4</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot5 >=0 && tot5 <=2 ? '1px solid' : 'none') }} pt={1} variant="h5">0-2</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot6 >=5 && tot6 <=8 ? '1px solid' : 'none') }} variant="h5">5-8</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot6 >=2 && tot6 <=4 ? '1px solid' : 'none') }} pt={1} variant="h5">2-4</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot6 >=0 && tot6 <=1 ? '1px solid' : 'none') }} pt={1} variant="h5">0-1</Typography>
            </GridLeft>
            <GridLeft item xs={1.5}>
              <Typography sx={{ textAlign: 'center', border: (tot7 >=9 && tot7 <=13 ? '1px solid' : 'none') }} variant="h5">9-13</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot7 >=4 && tot7 <=8 ? '1px solid' : 'none') }} pt={1} variant="h5">4-8</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot7 >=0 && tot7 <=3 ? '1px solid' : 'none') }} pt={1} variant="h5">0-3</Typography>
            </GridLeft>

            <GridLeft minHeight={250} item xs={1.5}>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '80%', transform: 'rotate(90deg)'}}>Criminal History</Typography>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Education Employment and Finacial Situation</Typography>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Family and Social Support</Typography>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Neighborhood Problems</Typography>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Substance Abuse</Typography>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Peer Associations</Typography>
            </GridLeft>
            <GridLeft minHeight={250} item xs={1.5}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Criminal Attitudes and Behavioral Patterns</Typography>
            </GridLeft>

            <Grid item xs={1}>
              <Typography variant="h5">Total</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="h5" sx={{textAlign: 'center', border: '1px solid'}}>{totCST}</Typography>
            </Grid>

          </Grid>

        
      </Box>
    </Dialog>
  );
};

export default CSTScoringGuide;

CSTScoringGuide.defaultProps = {
  open: false,
  setOpen: () => {},
};

CSTScoringGuide.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
